import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ICON_BASE_PATH = "/uploads/Industries/"; 
const slugify = (text) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};

const foodAndBeveragesSlug = slugify("Food & Beverages");

export default function Indus() {
    const [data, setData] = useState({ Industries: [] }); 
    useEffect(() => {
        fetch('/uploads/data.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data.json');
                }
                return response.json();
            })
            .then(fetchedData => {
                setData(fetchedData); 
            })
            .catch(error => {
                console.error("Could not fetch data:", error);
            });
    }, []); 

    const industries = data.Industries || [];

    return (
        <section className="relative w-full overflow-hidden">
            <div className="mx-auto max-w-6xl px-4 p-14 sm:px-6">
                <div className="mb-12">
                    <p className="font-uber text-center text-[26px] font-bold leading-[32px] sm:text-[30px] sm:leading-[38px] xl-custom:text-[32px] xl-custom:leading-[42px] px-16">
                       Playables add interactivity to advertising across industries — from food and retail to automotive and entertainment — designed to capture attention, drive action, and deliver measurable results
                    </p>
                </div>
                
                {industries.length === 0 && <p className="text-center">Loading industries...</p>}
                
                <div className="flex flex-wrap justify-center gap-6">
                    {industries.map((industryItem, index) => {
                        const industryName = industryItem.name;
                        const industrySlug = slugify(industryName);
                        const imagePath = ICON_BASE_PATH + industryItem.IndustryIcon;
                        
                        const linkTo = 
                            industrySlug === foodAndBeveragesSlug
                                ? `/Industries/${foodAndBeveragesSlug}`
                                : `/Industries/${industrySlug}`;

                        return (
                            <Link 
                                to={linkTo} 
                                key={index} 
                                className="bg-gray-200 rounded-lg p-4 flex flex-col items-center text-center shadow-lg w-full sm:w-[calc(50%-12px)] md:w-[calc(33.33%-16px)] lg:w-[calc(25%-18px)]"
                            >
                                <div className="mb-2">
                                    <img
                                        src={imagePath}
                                        alt={`${industryName} icon`}
                                        className="w-20 h-20"
                                    />
                                </div>
                                <h3 className="font-uber text-[16px] font-normal leading-[24px] text-black mb-2">{industryName}</h3>
                            </Link>
                            
                        );
                    })}
                </div>
            </div>
        </section>
    );
}